export const WIFI_BACKUP_PRODUCT_ID = '48120';
export const MAX_LENGTH = 31;
export const MIN_SCREEN_SIZE = 408;
export const Address_Change = 'Change';
export const STREAM_TV_PRODUCT_ID = 'acc13960007';
export const APPLY_OFFER = 'apply offer';
export const ABANDON_DISCOUNT_SEDOFFERID = '450548';
export const PROGRESSIVE_PLANS_PAGE = 'progressiveplans';
export const FIR_TAG_YES = 'fir_y';
export const FIR_TAG_NO = 'fir_n';
